module.exports = __webpack_public_path__ + "img/better@2x.36728aa4.png";